/* 馬超傳・第 2 章上半：蒲阪津（211 年）
 * 黃河由北往南流過地圖東邊；徐晃、朱靈夜渡蒲阪津，在河西岸立營。梁興、馬超從西邊來夜襲，天亮前退回西邊。 */
export const XU = [5000, 2100], START = [900, 2500], EXIT = [500, 2500];
export default {
  id: 'machao_puban', name: '蒲阪津', W: 7200, H: 4400, seed: 2111,
  bases: [START, XU],
  rivers: [{ pts: [[6300, -100], [6150, 1500], [6350, 2800], [6200, 4500]], hw: 380, fords: [] }],
  roads: [{ pts: [START, [2600, 2400], [4000, 2200], XU, [5800, 2000]], w: 130 }],
  rocks: [[2500, 900, 420, 200], [2700, 3700, 420, 200], [4300, 3800, 360, 170], [4200, 700, 360, 170]],
  woods: 0.45,
  sight: 0.6,
  clearings: [[START[0], START[1], 450], [XU[0], XU[1], 700], [3300, 2300, 400]],
  marsh: [[5900, 2000, 220, 110]],
  tents: [{ x: XU[0], y: XU[1], n: 8, r: 460, chief: true, col: '#3b5a99', flag: '徐' }],
  grass: [[3600, 1700, 260, 110], [3700, 2900, 260, 110]],
};
